import React from 'react'
import { AssetView, BalanceView, BalanceWrapper, FiatValue, Footer, GrayWrapper, Input, InputWrapper, MaxButton } from './style'
import LoadingBar from '../../components/LoadingBar'
import { floorAssetAmount, roundAssetAmount } from '../../util/Util'

interface AssetInputProps {
  label: 'Sell' | 'Buy'
  assetLogo: string
  assetSymbol: string
  value: string
  onChange: (value: string) => void
  isLoading?: boolean
  balance: number
  /** The amount's value in the reporting currency, already formatted. */
  fiatValue?: string
}

// One side of the conversion: the amount (typed on the Sell side, quoted on
// the Buy side), its value in the reporting currency under it, and the asset
// on the right, with the balance that pays for a sale and a Max shortcut.
const AssetInput = ({
  label, assetLogo, assetSymbol, value, onChange, isLoading, balance, fiatValue
}: AssetInputProps): JSX.Element => {
  const isSell = label === 'Sell'
  return (
    <InputWrapper>
      <GrayWrapper>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0, flex: 1 }}>
          <span className='side-label'>{label}</span>
          {isLoading
            ? <LoadingBar style={{ height: 30, width: 130 }}/>
            : <Input
              inputMode='decimal'
              disabled={!isSell}
              placeholder="0"
              aria-label={`${label} amount in ${assetSymbol}`}
              value={value}
              onUserInput={onChange}
            />}
          <FiatValue aria-live='polite'>{fiatValue ?? '\u00a0'}</FiatValue>
        </div>
        <Footer>
          <AssetView>
            <img src={assetLogo} alt={assetSymbol} />
            <span>{assetSymbol}</span>
          </AssetView>
          <BalanceWrapper>
            <BalanceView>{roundAssetAmount(assetSymbol, balance)} {assetSymbol}</BalanceView>
            {isSell && <MaxButton type='button' onClick={() => onChange(floorAssetAmount(assetSymbol, balance))}>Max</MaxButton>}
          </BalanceWrapper>
        </Footer>
      </GrayWrapper>
    </InputWrapper>
  )
}

export default AssetInput
